import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import { GetDataItem, toggleComment } from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import { DataSearch } from "./Components/Services";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import { Set } from "../../../../Request";
import { Button, TextField } from "@mui/material";
import ItemComment from "../../../../App/Panel/Comments/subsets/ItemComment";
import { RtlMui } from "../../../../App/component/rtlMui";
import { renderTimeMonth } from "../../../../Web/Common/Function";

import useImg from '../../../../App/assets/images/user.png';

function ItemsComments({ isApp }) {

  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
  };

  const [filter, setFilter] = useState({ rel_type: "item" });
  const [state, setstate] = useState(initialState);
  useEffect(() => {
    ItemHandler();
  }, []);
  const ItemHandler = (pageNumber = 1, data, limit, index, filter) => {
    setstate({ ...state, loading: true });
    GetDataItem(pageNumber, data, limit, index, filter).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };
  const SearchComment = data => {
    setstate({ ...state, loading: true });
    DataSearch({ name: data }).then(data => {
      setstate({ loading: false, data: data });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست کامنت ها</title>
      </Helmet>
      {isApp && <>
        {state.loading
          ? <Loading col="12" height="50px" count="3" />
          : state?.data?.data?.length > 0
            ? state?.data?.data.map((item, index) => (
              <ItemComment replayEV={() => setstate({ ...state, modal: item.id })} data={item} key={index} />
            ))
            : <p className="text-center mt-3 bg-transparent">  کامنتی یافت نشد !   </p>
        }
      </>}


      <>
        {!isApp && <DataTable
          loading={state.loading}
          heads={[
            {
              title: "نام و نام خانوادگی نظر دهنده",
              keyName: "fullname",
              key: "comenter",
            },
            {
              title: "متن کامنت",
              key: "text",
              type: "long",
            },
            {
              title: "تعداد پاسخ",
              key: "replies_count",
            },
          ]}
          textEmpty="کامنتی ثبت نشده"
          list={state.data && state.data.data}
          data={state.data}
          search={SearchComment}
          function={ItemHandler}
          currentPage={state.data && state.data.current_page}
          header="لیست کامنت های مجموعه شما"
          links={[
            {
              function: selected => {
                setstate({ ...state, modal: selected[0] });
              },
              color: "info",
              size: "col-md-2",
              html: "مشاهده",
              type: "show",
              main: true,
            },
          ]}
        />
        }
      </>
      <CustomModal
        show={state.modal}
        handleClose={() => {
          ItemHandler();
          setstate({ ...state, modal: false });
        }}
        header={"مشاهده کامنت"}
      >
        <CommentInfo
          ItemHandler={ItemHandler}
          value={
            state.data.data &&
            state.data.data.filter(item => item.id === state.modal)[0]
          }
          setstate={setstate}
          state={state}
          isApp={isApp}
        />
      </CustomModal>
    </Fragment>
  );
}
const CommentInfo = ({ value, setstate, state, ItemHandler, isApp }) => {
  const { form, setForm, sendData, loading, changeStatus, loadingBtn } =
    useComment();
  const renderData = data => {
    switch (data.rel_type) {
      case "admin":
        return {
          text: "پشتیبان",
          right: true,
          status: false,
          label: null,
        };
        break;
      case "manager":
        if (data.status == "on") {
          return {
            text: "مدیر مجموعه",
            right: false,
            status: "active",
            label: <span className="badge bg-success">فعال</span>,
          };
        } else {
          return {
            text: "مدیر مجموعه",
            right: false,
            status: "deactive",
            label: <span className="badge bg-danger">غیر فعال</span>,
          };
        }

      case "user":
        if (data.status == "on") {
          return {
            text: value.comenter.fullname,
            right: false,
            status: "active",
            label: <span className="badge bg-success">فعال</span>,
          };
        } else {
          return {
            text: value.comenter.fullname,
            right: false,
            status: "deactive",
            label: <span className="badge bg-danger">غیر فعال</span>,
          };
        }

      default:
        break;
    }
  };
  return (
    <div>
      <div className={isApp && "d-flex align-items-center mb-2"}>
        {isApp &&
          <div style={{ flex: "0 0 50px" }}>
            <img src={useImg} width={38} height={38} />
          </div>
        }

        <h6 className={isApp && "d-flex flex-column mb-0"}>
          {value && value.comenter && value.comenter.fullname}
          {isApp && <span className="mt-1">{renderTimeMonth(value?.created_at)}</span>}
        </h6>

      </div>
      <div className={isApp && "mb-4"}>
        <p style={{ fontSize: "12px" }}>{value && value.text}</p>
      </div>
      {value &&
        value.replies &&
        value.replies.map((message, count) => {
          return (
            <div key={count} className="border p-2 mb-2">
              <h6>{renderData(message)["text"]}</h6>

              <p style={{ fontSize: "10px" }}>{message.message}</p>
            </div>
          );
        })}
      <div className="d-flex flex-column">
        <RtlMui>
          <TextField
            fullWidth
            size="small"
            label={"پاسخ شما"}
            multiline
            rows={2}
            className="input-control input-input"
            onChange={({ target: { value } }) => {
              setForm({ ...form, message: value });
            }}
          />
        </RtlMui>
      </div>
      <div className="d-flex justify-content-center mt-2 boxBtnPrimary">
        <Button
          className={isApp && "w-100"}
          variant="contained"
          onClick={() => {
            sendData({ commnet_id: value.id });
            setstate({ ...state, modal: false });
            ItemHandler();
          }}
          disabled={loading}
        >
          {loading ? "در حال ارسال " : "ارسال"}
        </Button>
      </div>
    </div>
  );
};
export default ItemsComments;

const useComment = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const sendData = async data => {
    setLoading(true);
    await Set({
      url: "/comment/manager_answer",
      data: { ...form, ...data },
    }).then(() => {
      setLoading(false);
    });
  };
  const changeStatus = async data => {
    setLoadingBtn(true);
    await Set({
      url: "/commentreplies/change_status",
      data: { ...form, ...data },
    }).then(() => {
      setLoadingBtn(false);
    });
  };
  return {
    form,
    setForm,
    sendData,
    loading,
    changeStatus,
    loadingBtn,
  };
};
